module.exports = __webpack_public_path__ + "static/media/_wales.e17e96dc.png";